import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { type LightPromoCodeDto } from "@modules/promoCode/gateway/promoCodeDto"
import dayjs from "dayjs"

type LightPromoCodeState = Omit<LightPromoCodeEntity, "getWordingDate">

export class LightPromoCodeEntity {
  id: string
  title: string
  code: string
  type: CouponType
  value: number
  createdAt: Date
  durationInMonths: number | null

  private constructor(lightPromoCode: LightPromoCodeState) {
    this.id = lightPromoCode.id
    this.title = lightPromoCode.title
    this.code = lightPromoCode.code
    this.type = lightPromoCode.type
    this.value = lightPromoCode.value
    this.createdAt = lightPromoCode.createdAt
    this.durationInMonths = lightPromoCode.durationInMonths
  }

  static fromDto(lightPromoCodeDto: LightPromoCodeDto): LightPromoCodeEntity {
    return new LightPromoCodeEntity({
      id: lightPromoCodeDto.id,
      title: lightPromoCodeDto.title,
      code: lightPromoCodeDto.code,
      type: lightPromoCodeDto.type,
      value: lightPromoCodeDto.value,
      createdAt: new Date(lightPromoCodeDto.createdAt),
      durationInMonths: lightPromoCodeDto.duration,
    })
  }

  getWordingDate(): string {
    if (this.durationInMonths === null) {
      return word("promoCode.date.unlimited", {
        date: dayjs(this.createdAt).format("L"),
      })
    }

    return word("promoCode.date.durationInMonths", {
      dateStart: dayjs(this.createdAt).format("L"),
      dateEnd: dayjs(this.createdAt).add(this.durationInMonths, "months").format("L"),
    })
  }
}
